import type { FC } from "react";
import { Card, CardRowSimple, ColoredLabel, type GridCard } from "widgets";

import { getCssColor } from "@/app-utils/color.ts";
import type { AttributeValue, Parent } from "@/graphql.js";

import { SampleParentTile } from "../../core/tiles/index.js";
import AttributeValuesCardRows from "./AttributeValuesCardRows.js";

export interface ISampleParentCardProps extends GridCard {
  parent: Parent;
  isEntitySummary?: boolean;
  title?: string;
}

const SampleParentsCard: FC<ISampleParentCardProps> = (props) => {
  const parent = props.parent;
  if (!parent) {
    return null;
  }

  return (
    <Card key="sample-parents-card" title={props.title ?? parent.parentType.name}>
      {props.isEntitySummary ? (
        <CardRowSimple label={"Name"} value={`${parent ? parent.name : "not defined"}`} />
      ) : (
        <CardRowSimple label={"Name"}>
          <SampleParentTile parent={parent} />
        </CardRowSimple>
      )}
      <CardRowSimple
        label={"Status"}
        value={
          parent ? (
            <ColoredLabel
              label={parent.status?.name ?? "not defined"}
              color={parent.status?.color ? getCssColor(parent.status.color) : undefined}
            />
          ) : (
            "not defined"
          )
        }
      />
      <CardRowSimple label={"Sample count"} value={`${parent ? parent.sampleCount : 0}`} />
      <AttributeValuesCardRows values={(parent.attributeValues ?? []) as AttributeValue[]} />
    </Card>
  );
};

export { SampleParentsCard };
